import { useTranslation } from "react-i18next";

import { Device } from "@devices/types";
import { getActiveConnectionType, getDeviceConnectionIcon, getDeviceConnectionLabel } from "@devices/utils/device";
import { StatusLabel } from "@shared/StatusLabel";

export const ConnectionStatus = ({ device }: { device: Device | null }) => {
    const { t } = useTranslation(["common", "sidepanels"]);
    const isOnline = Boolean(device?.isOnline);

    const connectionType = getActiveConnectionType(device?.lastState?.networks, isOnline);
    const connectionIcon = getDeviceConnectionIcon(connectionType, isOnline);

    let text: string;
    if (isOnline) {
        const connectionLabel = getDeviceConnectionLabel(connectionType);
        text = connectionLabel
            ? t("sidepanels:devicePanel.status.onlineWithConnection", { connection: connectionLabel })
            : t("common:status.online");
    } else {
        text = t("sidepanels:devicePanel.status.offline");
    }

    return (
        <StatusLabel tone={isOnline ? "positive" : "error"} icon={`fa-solid ${connectionIcon}`}>
            {text}
        </StatusLabel>
    );
};
